import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import copy from "copy-to-clipboard";

import imageOptions from "./data/images";
import postTypeOptions from "./data/postTypes";
import postData from "./data/messages.json";

export default function PostDownload({ postType, postMessage, postImg }) {
  const [marketingUrl, setMarketingUrl] = useState("");
  const [copied, setCopied] = useState(false);

  if (!postType || !postMessage || !postImg) return null;

  const type = postTypeOptions.find((p) => p.value === postType);
  const message = postData.messages.find((m) => m.id === postMessage);
  const image = imageOptions.find((i) => i.id === postImg);

  let filename = null;

  if (type && image) {
    let formattedImage = imageOptions.find(
      (f) => f.name === image.name && f.type === type.suffix
    );

    if (formattedImage) filename = formattedImage.src;
  }

  function onCopyClick() {
    if (!message || !message.text) return;

    copy(message.text);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 5000);
  }

  return (
    <div style={{ textAlign: "left", margin: "20px 0" }}>
      <Button
        size="large"
        positive
        content="Download Image"
        icon="download"
        as="a"
        labelPosition="right"
        download
        href={filename}
      />
      <Button
        content={copied ? "Copied" : "Copy Message"}
        icon={copied ? "circle check" : "copy"}
        size="large"
        primary
        onClick={() => onCopyClick()}
        labelPosition="right"
      />
    </div>
  );
}
